export default function decimal(Vue) {
  /* eslint-disable */
  Vue.directive('decimal', {
    inserted(el, binding, vnode) {
      // 获取input元素
      const input = el.querySelector('input') || el;
      // 获取指令的参数，即小数位数
      const precision = binding.arg || 0;
      // 获取指令的值，即最小值和最大值
      const min = parseFloat(binding.value?.min) || 0;
      const max = parseFloat(binding.value?.max) || Infinity;

      // 初始化上次有效值为input的值
      let lastValidValue = input.value;
      // 初始化是否正在输入的标志
      let isComposing = false;

      // 判断是否允许负数
      const allowNegative = min < 0;

      // 创建自定义事件
      function createCustomEvent(value) {
        return {
          target: { value },
          currentTarget: { value },
          preventDefault: () => {},
          stopPropagation: () => {},
        };
      }

      // 监听input事件
      input.addEventListener('input', function (e) {
        // 如果正在输入，则不处理
        if (isComposing) return;

        // 获取input的值
        let value = this.value;

        // 根据是否允许负数决定过滤规则
        value = value.replace(new RegExp(`[^\\d.${allowNegative ? '-' : ''}]`, 'g'), '');

        // 如果不允许负数，直接移除所有负号
        if (!allowNegative) {
          value = value.replace(/-/g, '');
        } else {
          // 允许负数时，只保留开头的负号
          if (value.startsWith('-')) {
            value = '-' + value.slice(1).replace(/-/g, '');
          } else {
            value = value.replace(/-/g, '');
          }
        }

        // 获取小数点的位置
        const decimalIndex = value.indexOf('.');
        if (decimalIndex !== -1) {
          // 只保留小数点后precision位
          value =
            value.substring(0, decimalIndex + 1) +
            value.substring(decimalIndex + 1).replace(/\./g, '');
        }

        // 将字符串转换为数组，按小数点分割
        const parts = value.split('.');
        if (parts.length > 1) {
          // 只保留小数点后precision位
          parts[1] = parts[1].substring(0, precision);
          value = parts.join('.');
        }

        if (value === '' || (allowNegative && value === '-')) {
          updateValue(value);
          return;
        }

        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
          // 检查是否超过最大值
          if (numValue > max) {
            value = max.toFixed(precision);
          }
          // 如果不允许负数且值为负，恢复上次有效值
          else if (!allowNegative && numValue < 0) {
            value = lastValidValue;
          }
        }

        lastValidValue = value;
        updateValue(value);
      });

      input.addEventListener('blur', function () {
        let value = this.value;

        // 新增：清除末尾的小数点（如 "1." → "1"）
        if (value.endsWith('.')) {
          value = value.slice(0, -1);
        }

        if (value === '' || (allowNegative && value === '-')) {
          updateValue(value);
          return;
        }

        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
          updateValue('');
          return;
        }

        // 确保不小于最小值
        if (numValue < min) {
          value = min.toFixed(precision);
        }

        lastValidValue = value;
        updateValue(value);
      });

      input.addEventListener('change', function (e) {
        e.preventDefault();
        const event = createCustomEvent(this.value);
        if (vnode.componentInstance) {
          vnode.componentInstance.$emit('change', this.value);
        } else if (vnode.data?.on?.change) {
          vnode.data.on.change(event);
        }
      });

      input.addEventListener('compositionstart', () => (isComposing = true));
      input.addEventListener('compositionend', () => {
        isComposing = false;
        input.dispatchEvent(new Event('input'));
      });

      function updateValue(value) {
        input.value = value;
        const event = createCustomEvent(value);

        if (vnode.componentInstance) {
          vnode.componentInstance.$emit('input', value);
        } else if (vnode.data?.on?.input) {
          vnode.data.on.input(event);
        }
      }
    },
  });
}
